module.exports = __webpack_public_path__ + "img/well-being-data.0ddefb3a.svg";